<nb-card class="model-full">
  <nb-card-header>Validar criterios</nb-card-header>

  <nb-card-body>
    <div class="row">
      <div class="col-12" >
        <div class="form-group">
            <input class="col-11" type="text" nbInput fullWidth (keyup)="this.resultado = this.modalService.validaExpresion(data.currentValueCV, data.vTipo)" id="editaCampoCV" name="editaCampoCV" [(ngModel)]="data.currentValueCV"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" >
        <div class="form-group">
          <div>
            <label class="label">{{resultado}}</label>
          </div>
        </div>
      </div>
    </div>

  </nb-card-body>

  <nb-card-footer>
    <div class=" row ">
      <div class="col-9 text-left" style="display: inline-flex;">
        <button nbButton size="medium" status="info" (click)="cerrarVentanaModal()"><nb-icon icon="close-outline"></nb-icon> Cancelar</button>
      </div>
      <div class="col-2">
        <button nbButton size="medium" status="primary" (click)="aceptarVentanaModal()"><nb-icon icon="save-outline"></nb-icon> Aceptar</button>
      </div>
    </div>

  </nb-card-footer>

</nb-card>
